import { render, staticRenderFns } from "./Foto.vue?vue&type=template&id=17c0f0be&"
import script from "./Foto.vue?vue&type=script&lang=js&"
export * from "./Foto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports